import { useAuth0 } from '@auth0/auth0-react'
import { Client } from '@hapi/nes/lib/client'
import { useEffect } from 'react'
import { queryClient } from 'src'
import { localStorageItemKeys } from '~constants/local-storage-items'
import { webSocketBase } from '~utils/base-url'

export type WsString = `ws://${string}` | `wss://${string}`

export function useNotificationBannersSocket() {
  const { getAccessTokenSilently } = useAuth0()

  useEffect(() => {
    const client = new Client(webSocketBase() as WsString)

    const start = async () => {
      try {
        const token = await getAccessTokenSilently()

        const impersonate = localStorage.getItem(
          localStorageItemKeys.impersonate,
        )
          ? JSON.parse(
              localStorage.getItem(localStorageItemKeys.impersonate) as string,
            )
          : undefined

        await client.connect({
          auth: {
            headers: {
              Authorization: token,
              'x-impersonate': impersonate ? impersonate.id : '',
            },
          },
          retries: 3,
        })

        client.subscribe('/notification-banners', () => {
          queryClient.invalidateQueries({
            predicate: (query) => {
              return (
                typeof query.queryKey[0] === 'string' &&
                query.queryKey[0].includes('/notification-banners')
              )
            },
          })
        })
      } catch (error) {
        console.error('Notification banners WebSocket connection error:', error)
      }
    }

    start()

    return () => {
      try {
        client.disconnect()
      } catch (e) {
        // ignore
      }
    }
  }, [getAccessTokenSilently])
}
